// extracted by mini-css-extract-plugin
export default {"component-root":"base__component-root--Zh9-I"};